import { Button } from '@mui/material';
import { FileDownload, Visibility, ExpandMore } from '@mui/icons-material';

import './RegionalTableHeader.css';
import { RegionalTableHeaderProps } from './RegionalTableHeader.types';

/**
 * Renders a collapsible header for regional pricing tables with action buttons
 *
 * @param props - The component props
 * @returns JSX element containing the regional table header
 */
export function RegionalTableHeader({
  title,
  isCollapsed,
  onToggle,
  onExport,
  onViewDetails,
  showExport = true,
  showViewDetails = true,
  isMobile = false
}: RegionalTableHeaderProps) {
  return (
    <div className="regional-header">
      <div className="regional-header-left" onClick={onToggle}>
        <h3 className="regional-title">{title}</h3>
        <ExpandMore className={`collapse-icon ${isCollapsed ? 'collapsed' : ''}`} />
      </div>
      <div className="regional-header-buttons">
        {showExport && onExport && (
          <Button size="small" startIcon={<FileDownload />} onClick={onExport} className="export-regional-button">
            {!isMobile && 'Експорт'}
          </Button>
        )}
        {showViewDetails && onViewDetails && (
          <Button size="small" startIcon={<Visibility />} onClick={onViewDetails} className="view-details-button">
            {isMobile ? 'Детально' : 'Детальний перегляд'}
          </Button>
        )}
      </div>
    </div>
  );
}
